import { useCompactMoney } from "@/lib/useCompactMoney";
import { ReportShell, Section } from "./atoms";

export default function CashFlowView({ cf, onExport, onShare }) {
  const { money } = useCompactMoney();
  const op = cf.operating;
  const opRows = (op.items && op.items.length)
    ? op.items
    : [{ name: "No operating activity in period", amount: 0 }];
  return (
    <ReportShell title="Cash Flow" kind="cash-flow" onExport={onExport} onShare={onShare} testid="cashflow-view">
      <Section
        title="Operating Activities"
        rows={opRows}
        totalLabel="Net cash from operating activities"
        totalValue={op.net}
        accent
      />
      <Section
        title="Investing Activities"
        rows={cf.investing.items.length ? cf.investing.items : [{ name: "No investing activity in period", amount: 0 }]}
        totalLabel="Net cash from investing"
        totalValue={cf.investing.net}
      />
      <Section
        title="Financing Activities"
        rows={cf.financing.items.length ? cf.financing.items : [{ name: "No financing activity in period", amount: 0 }]}
        totalLabel="Net cash from financing"
        totalValue={cf.financing.net}
      />
      <div className="bg-[#0b5d9e] text-white mt-4 px-4 py-3 flex items-center justify-between" data-testid="cf-net-change">
        <div className="font-display font-bold text-lg">Net Change in Cash</div>
        <div className="font-mono-fin text-2xl">{money(cf.net_change_in_cash)}</div>
      </div>
    </ReportShell>
  );
}
